import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";
import { fetchServices, services } from "../../locales/services";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const Footer2 = ({ noNewsletters }) => {
  const [updatedServices, setUpdatedServices] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const loadServices = async () => {
      const data = await fetchServices();
      setUpdatedServices(data.slice(0, 6));
    };

    loadServices();
  }, []);

  const handleServiceClick = (service) => {
    navigate("/service-details", { state: { service } });
  };
  const isMobile = useMediaQuery("(max-width:868px)");
  const handleSuccessStoriesClick = () => {
    navigate("/about", { state: { scrollToReviews: true } });
  };

  return (
    <footer
      className="template-footer template-footer-white template-hover-tertiary"
      style={{
        marginTop: "20vh",
        backgroundColor: "#0a0a0a",
        color: "#fff",
      }}
    >
      <div
        className="footer-inner bg-size-cover bg-color-fourth"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="footer-widgets">
            <div className="row">
              {/* Logo and Contact Info */}
              <div className="col-lg-3 col-md-6">
                <div className="widget text-widget">
                  <div className="footer-logo text-center">
                    <Link to="/" style={{ display: "block" }}>
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "bold",
                            color: "#fff",
                          }}
                        >
                          {t("footer.name")}
                        </span>
                        <span
                          style={{
                            fontSize: "1.5rem",
                            color: "#fff",
                          }}
                        >
                          {t("footer.hospital")}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <p style={{ marginTop: "15px", fontSize: "1rem" }}>
                    {t("footer.footerText")}
                  </p>
                  <ul
                    className="contact-list"
                    style={{ paddingLeft: "0", marginTop: "15px" }}
                  >
                    <li>
                      <a
                        href="https://www.google.com/maps/place/Dr.+Lakdawala+Eye+Hospital/@21.174524,72.836912,17z/data=!4m6!3m5!1s0x3be04e63a5de0acb:0x9aefd33e3d6090c7!8m2!3d21.1745239!4d72.8369123!16s%2Fg%2F1v16nrxv?hl=en&entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D"
                        style={{ color: "#fff", fontSize: "1rem" }}
                      >
                        <FaMapMarkerAlt
                          style={{
                            marginRight: "10px",
                            fontSize: "1.2rem",
                            color: "var(--color-doctor)",
                          }}
                        />
                        {t("footer.address")}
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:imu52in@yahoo.com"
                        style={{ color: "#fff", fontSize: "1rem" }}
                      >
                        <FaEnvelope
                          style={{
                            marginRight: "10px",
                            fontSize: "1.2rem",
                            color: "var(--color-doctor)",
                          }}
                        />
                        imu52in@yahoo.com
                      </a>
                    </li>
                    <li>
                      <a
                        href="tel:+01234567899"
                        style={{ color: "#fff", fontSize: "1rem" }}
                      >
                        <FaPhone
                          style={{
                            marginRight: "10px",
                            fontSize: "1.2rem",
                            color: "var(--color-doctor)",
                          }}
                        />
                        +91 89808 63464
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Services and About Us */}
              <div className="col-lg-6 col-md-12">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="widget nav-widget">
                      <h4
                        className="widget-title"
                        style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                      >
                        {t("footer.popularServices")}
                      </h4>
                      <ul
                        className="nav-links"
                        style={{
                          listStyle: "none",
                          paddingLeft: "0",
                          fontSize: "1rem",
                        }}
                      >
                        {updatedServices.map((service, index) => (
                          <li key={index}>
                            <div
                              onClick={() => handleServiceClick(service)}
                              style={{ cursor: "pointer" }}
                              className="service-link"
                            >
                              {t(
                                `servicesPage.service${service.sortOrder}.${service?.title}`
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="widget nav-widget">
                      <h4
                        className="widget-title"
                        style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                      >
                        {t("footer.aboutUs")}
                      </h4>
                      <ul
                        className="nav-links"
                        style={{
                          listStyle: "none",
                          paddingLeft: "0",
                          fontSize: "1rem",
                        }}
                      >
                        <li>
                          <a
                            href="/doctor"
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                          >
                            {t("pageBanner.doctor")}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/blog"
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                          >
                            {t("home.newsTitle1")}
                          </a>
                        </li>{" "}
                        <li>
                          <a
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                            onClick={handleSuccessStoriesClick}
                          >
                            {t("footer.successStories")}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/contact"
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                          >
                            {t("footer.needSupport")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Newsletter and Opening Hours */}
              <div className="col-lg-3 col-md-12">
                <div className="widget newsletters-widget">
                  <div className="opening-notice" style={{ marginTop: "" }}>
                    <h6 style={{ fontSize: "1.2rem", marginBottom: "5px" }}>
                      <i
                        className="far fa-clock"
                        style={{ color: "var(--color-doctor)" }}
                      />{" "}
                      {t("header.openingHours")}
                    </h6>
                    <p style={{ fontSize: "1rem", }}>
                      {t("doctorPage.monday")} - {t("doctorPage.saturday")}:{" "}
                      {t("doctorPage.morning")} 10:30AM-1:30PM |{" "}
                      {t("doctorPage.evening")} 5PM-8PM
                    </p>
                  </div>
                  <a
                    style={{
                      marginTop: "50px",
                      backgroundColor: "transparent",
                      height: "140px",
                      borderTop: "2px solid lightgray",
                      borderBottom: "2px solid lightgray",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: "8px",
                      paddingBottom: "10px",
                      cursor: "pointer",
                      textDecoration: "none",
                      color: "inherit",
                      margin: isMobile ? "70px 10px 0 10px" : "50px 0 0 0",
                    }}
                    href="https://www.google.com/search?client=ms-android-samsung-ss&sca_esv=5fc29baf3309de07&sxsrf=AHTn8zqgCg7mfwBcPv9UHT204QltKwQZyg:1738218260441&kgmid=/g/11n2ntk9vc&q=Spectrum+Advanced+Eye+Care&shndl=30&source=sh/x/loc/act/m1/2&kgs=9f21403975d68969"
                  >
                    <p
                      style={{
                        fontSize: "22px",
                        marginBottom: "0",
                        textAlign: "center",
                        fontWeight: "bolder",
                        lineHeight: "38px",
                      }}
                    >
                      Associated with{" "}
                      <div
                        style={{
                          backgroundColor: "white",
                          fontSize: "32px", // Larger font for "Spectrum"
                          fontWeight: "bold",
                          fontFamily: "'Roboto', sans-serif", // You can change this to any font you prefer
                          // color: "#200a78", // Optional color change for emphasis
                          color: "var(--color-fourth)", // Optional color change for emphasis

                          marginTop: "4px",
                        }}
                      >
                        <div>Spectrum</div>
                        <div style={{ fontSize: "14px" }}>
                          Advanced Eye Care
                        </div>
                      </div>
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom (Copyright) */}
          <div
            className="copyright-area text-center"
            style={{ marginTop: "40px", padding: "20px 0" }}
          >
            <p style={{ fontSize: "1rem", color: "#fff" }}>
              © 2025{" "}
              <Link
                to="/"
                style={{ color: "#fff", textDecoration: "underline" }}
              >
                Dr. Lakdawala Eye Hospital
              </Link>
              . All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
